/**
 * Deckaura 11:11 Decision Index - storefront event publisher
 *
 * Add this file to the Shopify theme and call:
 *
 *   DeckauraDecisionIndex.publish({
 *     action: "reading_completed",
 *     tool: "love_tarot",
 *     category: "love",
 *     subcategory: "situationship",
 *     cards: ["the-lovers", "the-moon", "justice"],
 *     orientationPattern: "mixed",
 *     spread: "three_card",
 *     language: "en"
 *   });
 *
 * Never pass the user's question or any other free text.
 */
(function () {
  "use strict";

  var EVENT_NAME = "deckaura:decision_index";
  var SCHEMA_VERSION = "1.0";

  var ACTIONS = new Set([
    "reading_completed",
    "result_saved",
    "result_shared",
    "paid_reading_started"
  ]);

  var TOOLS = new Set([
    "free_tarot",
    "love_tarot",
    "yes_no_tarot",
    "daily_card",
    "random_card",
    "birth_card",
    "rune_reading",
    "luminous_roots_oracle",
    "other"
  ]);

  var CATEGORIES = new Set([
    "love",
    "career",
    "money",
    "self_growth",
    "family",
    "friendship",
    "spirituality",
    "health_wellbeing",
    "other",
    "not_provided"
  ]);

  var ORIENTATION_PATTERNS = new Set([
    "upright",
    "reversed",
    "mixed",
    "not_applicable"
  ]);

  function allow(value, allowed, fallback) {
    var normalized = String(value || "").trim().toLowerCase();
    return allowed.has(normalized) ? normalized : fallback;
  }

  function slug(value, fallback) {
    var normalized = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 64);
    return normalized || fallback;
  }

  function language(value) {
    var normalized = String(value || document.documentElement.lang || "en")
      .trim()
      .toLowerCase()
      .slice(0, 2);
    return /^[a-z]{2}$/.test(normalized) ? normalized : "en";
  }

  function publish(input) {
    if (
      !window.Shopify ||
      !Shopify.analytics ||
      typeof Shopify.analytics.publish !== "function"
    ) {
      return Promise.resolve(false);
    }

    var cards = Array.isArray(input && input.cards)
      ? input.cards.slice(0, 3).map(function (card) {
          return slug(card, "not_applicable");
        })
      : [];

    while (cards.length < 3) cards.push("not_applicable");

    var payload = {
      action: allow(input && input.action, ACTIONS, "reading_completed"),
      tool: allow(input && input.tool, TOOLS, "other"),
      category: allow(input && input.category, CATEGORIES, "not_provided"),
      subcategory: slug(input && input.subcategory, "not_provided"),
      card_1: cards[0],
      card_2: cards[1],
      card_3: cards[2],
      orientation_pattern: allow(
        input && input.orientationPattern,
        ORIENTATION_PATTERNS,
        "not_applicable"
      ),
      spread: slug(input && input.spread, "not_applicable"),
      language: language(input && input.language),
      schema_version: SCHEMA_VERSION
    };

    /*
     * Shopify.analytics.publish currently returns void, but callers need a stable
     * Promise contract so analytics can never interrupt the reading experience.
     */
    try {
      return Promise.resolve(
        Shopify.analytics.publish(EVENT_NAME, payload)
      ).then(function () {
        return true;
      }).catch(function () {
        return false;
      });
    } catch (_) {
      return Promise.resolve(false);
    }
  }

  window.DeckauraDecisionIndex = Object.freeze({ publish: publish });
})();

/* ynx-question-guard-v1 */
(function(){
    var localeRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    var localizedPath='/' + location.pathname.slice(localeRoot.length).replace(/^\/+|\/+$/g,'');
    if(localizedPath!=='/pages/yes-or-no-tarot') return;
  var message='Please enter one clear yes-or-no question before drawing a card.';
  function setError(text){
    var input=document.getElementById('ynxQ');
    if(!input) return false;
    var error=document.getElementById('ynxQError');
    if(!error){
      error=document.createElement('p'); error.id='ynxQError'; error.className='ynx__error';
      error.setAttribute('role','alert'); error.setAttribute('aria-live','polite');
      error.style.cssText='margin:7px 4px 0;color:#923027;font:700 .8rem/1.4 Arial,Helvetica,sans-serif;text-align:left';
      input.insertAdjacentElement('afterend',error);
      input.setAttribute('aria-describedby','ynxQError');
    }
    error.textContent=text||'';
    if(text) input.setAttribute('aria-invalid','true'); else input.removeAttribute('aria-invalid');
    return true;
  }
  function valid(){
    var input=document.getElementById('ynxQ');
    if(input&&input.value.trim()){ setError(''); return true; }
    setError(message); if(input) input.focus(); return false;
  }
  document.addEventListener('click',function(event){
    var target=event.target&&event.target.closest&&event.target.closest('#ynxDraw, #ynxAgain');
    if(!target||valid()) return;
    event.preventDefault(); event.stopImmediatePropagation();
  },true);
  document.addEventListener('keydown',function(event){
    if(event.key!=='Enter'||!event.target||event.target.id!=='ynxQ'||valid()) return;
    event.preventDefault(); event.stopImmediatePropagation();
  },true);
  document.addEventListener('input',function(event){
    if(event.target&&event.target.id==='ynxQ'&&event.target.value.trim()) setError('');
  },true);
})();
